export default __webpack_public_path__ + "static/media/summernight.bef58668.ogg";